export default __webpack_public_path__ + "static/media/crypto-lex.9c9f4df1.svg";